import { Route } from "react-router-dom";
import MainContainer from "../Components/Pages/MainContainer";
import FormMaterial from "../Components/Formulario/FormMaterial";
import jobPartDataForm from "../Components/Formulario/JobPartsDataForm";
import StatsCollector from "../Components/utils/stats/StatsCollector";
import JobsPerPartType from "../Components/utils/stats/JobsPerPartType";
import { Grid } from "@mui/material";

export const jobPartsRoutes = ({ color, variant }) => (
  <>
    <Route
      path="/JobParts"
      element={
        <Grid container columns={12}>
          <Grid columns={{ sm: 12, md: 6 }}>
            <MainContainer entity={"JobParts"} form={jobPartDataForm} />
          </Grid>
          <Grid columns={{ sm: 12, md: 3 }}>
            <StatsCollector route="jobs/complete">
              <JobsPerPartType rank={10} />
            </StatsCollector>
          </Grid>
        </Grid>
      }
    />
    <Route
      path="/JobParts/trash"
      element={
        <MainContainer entity={"JobParts/trash"} form={jobPartDataForm} />
      }
    />
    <Route
      path="/JobParts/add"
      element={
        <FormMaterial
          form={jobPartDataForm}
          collection="JobParts"
          task="new"
          title="Agregar Parte de Trabajo"
          subtitle="Definir las caracteristicas principales de la parte de trabajo evita el ingreso de trabajos irrealizables. Asignarlas a los tipos de trabajos correspondientes."
          submitText={"Agregar Parte de Trabajo"}
          color={color}
          variant={variant}
        />
      }
    />
    <Route
      path="/JobParts/copy/:id"
      element={
        <FormMaterial
          form={jobPartDataForm}
          collection="JobParts"
          task="copy"
          title="Copiar Parte de Trabajo"
          subtitle="Agregar una nueva parte de trabajo basada en una existente."
          submitText={"Agregar Parte de Trabajo"}
          color={color}
          variant={variant}
        />
      }
    />
    <Route
      path="/JobParts/edit/:id"
      element={
        <FormMaterial
          form={jobPartDataForm}
          collection="JobParts"
          task="edit"
          title="Editar Parte de Trabajo"
          subtitle="Los cambios en las caracteristicas de la parte de trabajo afectaran los trabajos que la utilicen."
          submitText={"Guardar cambios"}
          color={color}
          variant={variant}
        />
      }
    />
  </>
);
